import clsx from "clsx";
import React from "react";
import { Form } from "react-bootstrap";
import { exportScopeOptionItems, exportScopeValues } from "./const";

type Props = {
  useScope: boolean;
  showScopeNote?: boolean;
  selectedScope?: string;
  setSelectedScope?: (value: string) => void;
  hasSelectedRows: boolean;
  scopeLabels?: Record<string, string>;
};

const GridExportScopeOptions = ({
  useScope,
  showScopeNote = true,
  selectedScope,
  setSelectedScope,
  hasSelectedRows,
  scopeLabels
}: Props) => {
  const radioDisabled = (value: string) =>
    value === exportScopeValues.SELECTED ? !hasSelectedRows : false;

  return (
    <>
      {showScopeNote && (
        <div className="fs-sm">
          <strong>NOTE:</strong> Actions below apply only to items on the
          current page.
        </div>
      )}
      {useScope && (
        <div className={clsx(showScopeNote && "mt-10")}>
          {exportScopeOptionItems.map(radio => {
            const { value, label, bulkLabel } = radio || {};
            return (
              <Form.Check
                id={`grid-export-scope-radio-${value}`}
                data-testid={`grid_export_scope_radio_${value}`}
                key={value}
                label={
                  scopeLabels?.[value] ||
                  (bulkLabel && !showScopeNote ? bulkLabel : label)
                }
                type="radio"
                name="export-scope"
                onChange={() => setSelectedScope?.(value)}
                disabled={radioDisabled(value)}
                checked={selectedScope === value}
                className="mt-5"
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default GridExportScopeOptions;
